import React, { useState, useEffect, useMemo } from "react";
import ChangePassword from "./ChangePassword";
import MultiFactorAuth from "./MultiFactorAuth";
import DeleteAccount from "./DeleteAccount";
import "./SecurityDashboard.scss";

import DynamicHeader from "../../Header/DynamicHeader";

const SecurityDashboard = () => {
  const [activeSection, setActiveSection] = useState(null);
  const [pageState, setPageState] = useState("enter");

  useEffect(() => {
    const t = setTimeout(() => setPageState("idle"), 160);
    return () => clearTimeout(t);
  }, []);

  const sections = [
    { key: "change-password", label: "Зміна паролю" },
    { key: "2fa", label: "Двофакторна автентифікація" },
    { key: "delete", label: "Видалення акаунту" },
  ];

  const titleMap = {
    null: "Акаунт та безпека",
    "change-password": "Зміна паролю",
    "2fa": "Двофакторна автентифікація",
    "delete": "Видалення акаунту",
  };

  const currentTitle = useMemo(
    () => (activeSection ? titleMap[activeSection] : titleMap.null),
    [activeSection]
  );

  const onBack = () => {
    if (activeSection) setActiveSection(null);
    else window.history.back();
  };

  const renderComponent = () => {
    switch (activeSection) {
      case "change-password":
        return <ChangePassword />;
      case "2fa":
        return <MultiFactorAuth />;
      case "delete":
        return <DeleteAccount />;
      default:
        return (
          <div className="security-menu">
            <div className="sd-card">
              {sections.map((s) => (
                <button
                  key={s.key}
                  className="sd-item"
                  onClick={() => setActiveSection(s.key)}
                >
                  <span className="label">{s.label}</span>
                  <span className="chevron" aria-hidden="true">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M9 6l6 6-6 6"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </button>
              ))}
            </div>
          </div>
        );
    }
  };

  return (
    <>
      <DynamicHeader
        title={currentTitle}
        variant="glass"
        size="regular"
        showBack
        onBack={onBack}
        withSpacer
      />
      <div className={`security-dashboard page-${pageState}`}>
        {renderComponent()}
      </div>
    </>
  );
};

export default SecurityDashboard;
